// 风行统计接口

import httpRequest from '@/utils/request'

/**
 * 保存统计条件
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const saveStatic = data =>
  httpRequest.httpPost('/service/data/statistics/save', data)

/**
 * 获取统计条件列表
 * @returns {Promise | Promise<unknown>}
 */
export const getStaticList = () =>
  httpRequest.httpGet({
    url: '/service/data/statistics/lst'
  })

/**
 * 获取统计条件默认区间
 * @param carrierIds
 * @returns {Promise | Promise<unknown>}
 */
export const getRange = carrierIds =>
  httpRequest.httpGet({
    url: '/service/data/statistics/carrier/range',
    params: {
      carrierIds
    }
  })

/**
 * 统计预览
 * @param data
 * @returns {Promise<unknown>}
 */
export const previewStatic = data =>
  httpRequest.httpPost('/service/data/statistics/preview', data)

export const exportStatic = data =>
  httpRequest.httpPost('/service/data/statistics/export', data)
